import React from "react";
import { Link } from "react-router-dom";

function MarriedUserList({ marriedUsers }) {
  return (
    <div className="flex flex-wrap gap-4 p-2">
      {marriedUsers?.map((item) => {
        const user = item?.userId;
        const admin = item?.adminId;
        const spouse = item?.spouse;
        const marriedViaVmb = item?.marriedViaVmb;
        const isGuided = item?.isGuided;
        const guidedName = item?.guidedUser;

        const hasSpouseInfo =
          (marriedViaVmb && spouse) ||
          (isGuided && (guidedName || item?.spouse || item?.guidedUserId));

        return (
          <div
            key={item?._id}
            className="flex w-full flex-col items-center justify-between gap-2 rounded-lg bg-white p-2 shadow-md md:w-[40%] xl:w-[30%]"
          >
            <div className="flex w-full flex-col items-center gap-1 pt-2">
              <Link
                to={`/married-users/viewProfile/${user?._id}`}
                className="text-lg font-semibold text-blue-600 hover:underline"
              >
                {user?.name}
              </Link>
              <span className="rounded-full bg-textYellowLight px-3 py-0.5 text-xs font-semibold text-textGreen">
                {user?.maritalStatus}
              </span>
            </div>

            <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 text-xs text-gray-800 shadow-sm">
              <p className="font-semibold">
                Gender:{" "}
                <span className="font-normal text-black">{user?.gender}</span>
              </p>
              <p className="font-semibold">
                Email:{" "}
                <span className="break-all font-normal text-black">
                  {user?.primaryEmail}
                </span>
              </p>
              <p className="font-semibold">
                Phone:{" "}
                <span className="font-normal text-black">{user?.phone}</span>
              </p>
              <p className="font-semibold">
                DOB:{" "}
                <span className="font-normal text-black">
                  {user?.dob
                    ? new Date(user.dob).toLocaleDateString("en-CA")
                    : "NA"}
                </span>
              </p>

              {admin?.name && (
                <p className="flex flex-wrap gap-1 border-t border-gray-100 pt-2 font-semibold">
                  Updated Admin:
                  <span className="break-all font-normal text-black">
                    {admin?.name}
                  </span>
                </p>
              )}

              {item?.marriedDate && (
                <p className="flex flex-wrap gap-1 font-semibold">
                  Married Date:
                  <span className="font-normal text-black">
                    {new Date(item?.marriedDate).toLocaleDateString("en-CA")}
                  </span>
                </p>
              )}

              {hasSpouseInfo && (
                <div className="flex flex-col gap-1 border-t border-gray-100 pt-2">
                  <p className="text-xs font-bold text-black">Spouse Info</p>

                  {isGuided ? (
                    item?.spouse ? (
                      <>
                        <p className="font-semibold">
                          Name:{" "}
                          <Link
                            to={`/married-users/viewProfile/${item?.spouse?._id}`}
                            className="text-blue-600 hover:underline"
                          >
                            {item?.spouse?.name}
                          </Link>
                        </p>
                        <p className="font-semibold">
                          Email:{" "}
                          <span className="break-all font-normal text-black">
                            {item?.spouse?.primaryEmail}
                          </span>
                        </p>
                      </>
                    ) : item?.guidedUserId ? (
                      <>
                        <p className="font-semibold">
                          Name:{" "}
                          <Link
                            to={`/married-users/viewProfile/${item?.guidedUserId?._id}`}
                            className="text-blue-600 hover:underline"
                          >
                            {item?.guidedUserId?.name}
                          </Link>
                        </p>
                        {item?.guidedUserId?.primaryEmail && (
                          <p className="font-semibold">
                            Email:{" "}
                            <span className="break-all font-normal text-black">
                              {item?.guidedUserId?.primaryEmail}
                            </span>
                          </p>
                        )}
                      </>
                    ) : (
                      <p className="font-semibold">
                        Name:{" "}
                        <span className="font-normal text-black">{guidedName}</span>
                      </p>
                    )
                  ) : (
                    marriedViaVmb &&
                    spouse && (
                      <>
                        <p className="font-semibold">
                          Name:{" "}
                          <Link
                            to={`/married-users/viewProfile/${spouse?._id}`}
                            className="text-blue-600 hover:underline"
                          >
                            {spouse?.name}
                          </Link>
                        </p>
                        <p className="font-semibold">
                          Email:{" "}
                          <span className="break-all font-normal text-black">
                            {spouse?.primaryEmail}
                          </span>
                        </p>
                      </>
                    )
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MarriedUserList;